<template>
  <v-dialog v-model="dialog" max-width="900" persistent>
    <v-form lazy-validation v-model="valid" ref="form">
      <v-card>
        <v-card-title>
          <span class="headline">Transfer Detail</span>
        </v-card-title>
        <v-card-text>
          <v-row v-if="!loading">
            <v-col cols="12" class="mt-2">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="4">Bank Name :</v-col>
                <v-col cols="12" sm="12" md="6" lg="8">{{
                  item.accountNumber ? item.accountNumber.bankExternal.name : ""
                }}</v-col>
                <v-col cols="12" sm="12" md="6" lg="4">Account Number :</v-col>
                <v-col cols="12" sm="12" md="6" lg="8">{{
                  item.accountNumber ? item.accountNumber.accountNumber : ""
                }}</v-col>
                <v-col cols="12" sm="12" md="6" lg="4">Owner Name : </v-col>
                <v-col cols="12" sm="12" md="6" lg="8">{{
                  item.accountNumber ? item.accountNumber.ownerName : ""
                }}</v-col>
                <v-col cols="12" sm="12" md="6" lg="4">Total Amount :</v-col>
                <v-col cols="12" sm="12" md="6" lg="8">{{ formatPrice(item.amount) }}</v-col>
                <v-col cols="12" sm="12" md="6" lg="4">Subcon : </v-col>
                <v-col cols="12" sm="12" md="6" lg="8">{{ item.subconName }}</v-col>
                <v-col cols="12" sm="12" md="6" lg="4">INV# : </v-col>
                <v-col cols="12" sm="12" md="6" lg="8">{{ item.invoiceNumber }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="12" v-if="!hasPinCookies">
              <v-text-field
                outlined
                dense
                flat
                background-color="white"
                v-model="pin"
                label="Pin"
                persistent-hint
                hint="Masukan PIN yang diperoleh dari APP"
                :rules="[v => !!v || 'Pin is required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="fill-height" align-content="center" justify="center" v-if="loading">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Processing transfer bank, please wait...
            </v-col>
            <v-col cols="6">
              <v-progress-linear indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close" :disabled="loading" class="mr-2">
            Close
          </v-btn>
          <v-btn
            v-if="$rbac.can('subcon-payment.create')"
            color="primary"
            @click="save"
            :disabled="loading"
          >
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from "moment";
import cookies from "@/services/cookies";
export default {
  name: "dialog-confirmation-transfer",
  props: {
    dialog: Boolean,
    item: Object,
    loading: Boolean,
  },
  data() {
    return {
      valid: true,
      pin: "",
      hasPinCookies: false,
    };
  },
  methods: {
    checkPinCookies() {
      this.hasPinCookies = cookies.checkCookies();
      if (this.hasPinCookies) {
        this.pin = cookies.getCookies();
      }
    },
    save() {
      if (this.hasPinCookies) {
        this.$emit("save", { body: this.item, pin: this.pin });
      } else {
        if (this.$refs.form) {
          const isFormValid = this.$refs.form.validate();

          if (isFormValid) {
            cookies.generateCookies(this.pin);
            this.$emit("save", { body: this.item, pin: this.pin });
          } else {
            this.$store.dispatch("toast", {
              type: "error",
              message: "Form validation failed. Please input pin",
            });
          }
        } else {
          this.$store.dispatch("toast", {
            type: "error",
            message:
              "Error: Could not find this.$refs.form. The form element might not be rendered in the DOM.",
          });
        }
      }
    },
    close() {
      this.$emit("close");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(date) {
      return moment(date).format("DD-MM-yyyy");
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.checkPinCookies();
      }
    },
  },
};
</script>

<style></style>
